import { useQuery } from "@tanstack/react-query";
import useGetOrg from "src/hooks/useGetOrganization";
import { useGetAppSecretsRequest } from "src/services/organizations/queries/secrets";
import { AppType } from "src/types/apps";

import { RowSecretType } from "../SecretsCard/Table/TableBody";

export const useGetSecrets = () => {
	const { id } = useGetOrg();
	const { data: apps } = useQuery<AppType[]>({ queryKey: ["apps"], initialData: [] });
	const { data: appId } = useQuery<string>({ queryKey: ["apps", "selected"], initialData: "" });

	const { data, isLoading } = useGetAppSecretsRequest({ orgId: id, appId });

	const clietIdItem: RowSecretType = {
		name: "ID Cliente",
		secretKey: appId,
		createdAt: apps.find((i) => i.id === appId)?.createdAt ?? "",
		isClient: true,
		id: "id"
	};

	const rows: RowSecretType[] = [
		clietIdItem,
		...(data?.map((i) => ({ ...i, secretKey: "" })) ?? [])
	];

	return {
		rows,
		isLoading
	};
};
